import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";

const ViewSliderImages = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [error, setError] = useState("");
  const URL = process.env.REACT_APP_URL;

  useEffect(() => {
    axios
      .get(`${URL}sliderImage/${id}`)
      .then((response) => {
        setProduct(response.data);
        setError("");
      })
      .catch(() => {
        setError("Error fetching slider image details.");
      });
  }, [id, URL]);

  if (error) {
    return <div className="text-red-500 text-center mt-4">{error}</div>;
  }

  if (!product) {
    return <div className="text-center mt-4 text-gray-600">Loading...</div>;
  }

  return (
    <div className="flex justify-center items-center p-10 min-screen">
      <div className="bg-white shadow-lg rounded-xl w-full max-w-sm border p-6 border-gray-200">
        <div className="flex justify-center mb-4">
          <img
            src={`${URL}upload/${product.image || "default.jpg"}`}
            alt={product.title}
            className="w-40 h-40 object-cover rounded-lg border border-gray-300 shadow-sm"
          />
        </div>

        <div className="space-y-4">
          <div className="flex flex-col">
            <span className="text-gray-500 text-sm">Title:</span>
            <span className="text-lg font-semibold text-gray-900">
              {product.title}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="text-gray-500 text-sm">Description:</span>
            <p className="text-gray-700 text-base leading-relaxed">
              {product.description}
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-col space-y-3">
          {/* <Link to={`/editSliderImage/${product._id}`}>
            <button className="w-full px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
              Edit
            </button>
          </Link> */}
          <Link to="/sliderImage">
            <button className="w-full px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition">
              Back to List
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ViewSliderImages;
